const countdown = () => {

	let btnClick = document.querySelectorAll('.bomb .parts .part-wrap .click'),
		countdownStart = document.querySelector('.bomb .parts'),
		bang = document.querySelector('.bomb .bang'),		
		count = document.querySelectorAll('.bomb .count');
	
	// if(document.documentElement.clientWidth <= 991 && btnClick) {
	if(btnClick) {	
		btnClick.forEach(function(item) {
			item.addEventListener('click', (e) => {
				e.preventDefault();

				countdownStart.classList.add('hide');			
					
				three();
				setTimeout(two, 500);
				setTimeout(one, 1000);
				setTimeout(zero, 1500);
				setTimeout(bangShow, 2000);
				

				setTimeout(showNumbersComplete, 3000);
				
			});
		})
		

		function showNumbersComplete() {
	        window.location = btnClick[0].href;  
	    }

	    function hideCountdown() {    	
	    	count.forEach(item => {                 
	           item.classList.add('hide');
	        });   
	    }

	    function three() {
	    	hideCountdown();
	    	count[0].classList.remove('hide');    	
	    }
	    function two() {
	    	hideCountdown();
	    	count[1].classList.remove('hide');    	
	    }
	    function one() {
	    	hideCountdown();
	    	count[2].classList.remove('hide');    	
	    }
	    function zero() {
	    	hideCountdown();
	    	count[3].classList.remove('hide');    	
	    }
	    function bangShow() {  
	    	// bang.classList.add('fadeIn');  	
	    	bang.classList.remove('hide');
	    }
	}
}
export default countdown;